import styled from "@emotion/styled"
import { library } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faChevronLeft,
  faChevronRight,
  faHorizontalRule,
} from "@fortawesome/pro-light-svg-icons"
import React, { useContext } from "react"
import SlickSlider from "react-slick"
import "slick-carousel/slick/slick-theme.css"
import "slick-carousel/slick/slick.css"
import tw from "twin.macro"
import tailwindConfig from "../utils/tailwindConfig"
import ThemeContext from "../context/theme-context"

library.add(
  faChevronLeft,
  faChevronRight,
  faHorizontalRule
)

const breakpoints = tailwindConfig.theme.screens

const IconWrapper = styled.div`
  ${tw`inline-block w-auto h-auto`}
  width: 12px;
  @media screen and (min-width: ${breakpoints.sm}) {
    width: 42px;
  }
  &.slick-prev {
    /* left: calc(-42px - ${tailwindConfig.theme.spacing["12"]}); */
    left: 0;
    [data-icon="horizontal-rule"] {
      path {
        vertical-align: 0;
      }
      ${tw`hidden sm:inline-block`}
    }
  }
  &.slick-next {
    /* right: calc(-42px - ${tailwindConfig.theme.spacing["12"]}); */
    right: 0;
    [data-icon="horizontal-rule"] {
      path {
        vertical-align: 0;
      }
      ${tw`hidden sm:inline-block`}
    }
  }
  &::before {
    display: none;
  }
`
const PreviousArrow = ({ className, ...other }) => {
  return (
    <IconWrapper className={className} {...other}>
      <FontAwesomeIcon icon={["fal", "chevron-left"]} />
      <FontAwesomeIcon icon={["fal", "horizontal-rule"]} />
    </IconWrapper>
  )
}

const NextArrow = ({ className, ...other }) => {
  return (
    <IconWrapper className={className} {...other}>
      <FontAwesomeIcon icon={["fal", "horizontal-rule"]} />
      <FontAwesomeIcon icon={["fal", "chevron-right"]} />
    </IconWrapper>
  )
}

const StyledSlider = styled(SlickSlider)`
  padding-left: calc(12px + ${tailwindConfig.theme.spacing["4"]});
  padding-right: calc(12px + ${tailwindConfig.theme.spacing["4"]});
  /* offset height of dots div to keep spacing consistent */
  ${props => props.dots && { marginBottom: "27px" }}
  @media screen and (min-width: ${breakpoints.sm}) {
    padding-left: calc(42px + ${tailwindConfig.theme.spacing["12"]});
    padding-right: calc(42px + ${tailwindConfig.theme.spacing["12"]});
  }
  ${props =>
    props.vAlign === "middle"
      ? `.slick-track { display: flex; align-items: center; }`
      : ``}
  .slick-arrow {
    color: ${props => props.buttonColor};
    display: block;
    font-size: 24px;
  }
  .slick-dots {
    left: 0;
    right: 0;
    li button {
      ${tw`relative mt-4`}
    }
    li button::before {
      color: ${props => props.buttonColor};
      font-size: 10px;
    }
  }
`

const Slider = ({ children, contrastText, ...props }) => {
  const buttonColor = contrastText
    ? tailwindConfig.theme.colors.white.DEFAULT
    : tailwindConfig.theme.colors.gray.DEFAULT

  const defaultSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <NextArrow className="slick-arrow slick-next" />,
    prevArrow: <PreviousArrow className="slick-arrow slick-prev" />,
  }

  const settings = { ...defaultSettings, ...props }

  // Don’t render the slider server side because widths won’t be calculated correctly
  const { hydrated: isClient } = useContext(ThemeContext)

  return (
    <>
      {isClient && (
        <StyledSlider buttonColor={buttonColor} {...settings}>
          {children}
        </StyledSlider>
      )}
    </>
  )
}

export default Slider
